import { cn } from '@/lib/utils'
import * as React from 'react'

const Description = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => {
  //   const { descriptionId } = useFormField()
  return (
    <p
      data-slot="description"
      ref={ref}
      //   id={descriptionId}
      className={cn(
        'mt-1 text-left text-xs text-txt-secondary data-[status=error]:text-txt-error data-[status=success]:text-txt-success',
        className,
      )}
      {...props}
    />
  )
})
Description.displayName = 'Description'

export { Description }
